export const formatNumberEng = (amount, index) => {
  let num = Number(amount)
  if (isNaN(num)) {
    num = 0
  }

  let formattedNumber = num
  let suffix = ''

  if (num >= 1e9) {
    suffix = 'B'
    formattedNumber = num / 1e9
  } else if (num >= 1e6) {
    suffix = 'M'
    formattedNumber = num / 1e6
  } else if (num >= 1e3) {
    suffix = 'K'
    formattedNumber = num / 1e3
  }

  const idx = typeof index === 'number' ? index : (parseInt(index, 10) || 0)
  let result = formattedNumber.toFixed(idx)

  if (result.endsWith(',0') || result.endsWith('.0')) {
    result = result.slice(0, -2)
  }

  return `${result}${suffix}`
}

export function formatUnixToDate(timestamp) {
  const date = new Date(timestamp * 1000)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

export const formatCurrency = (val, index = 2) => {
  if (val === undefined || val === null) return '$0.00'
  const num = Number(val)
  if (isNaN(num)) return '$0.00'
  if (num < 0) {
    return `-$${formatNumberEng(Math.abs(num), index)}`
  }
  return `$${formatNumberEng(num, index)}`
}
